import { Component, OnInit } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { GetTags } from '../store/tags.action';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { MatDialog } from '@angular/material';
import { MergeTagsDialogComponent } from './merge-tags-dialog/merge-tags-dialog.component'

@Component({
  selector: 'app-listing-tags',
  templateUrl: './listing-tags.component.html',
  styleUrls: ['./listing-tags.component.scss']
})
export class ListingTagsComponent implements OnInit {
  tagList;
  tagsSelectedForMerge: Array<any> = [];
  enableMerge: boolean = false

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private notificationService: NotificationsService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.store.dispatch(new GetTags());
    this.store.select(state => state.tags.tags).pipe().subscribe(tags => {
      this.tagList = tags;
    });
  }

  selectTagForMerge(event, tagName) {
    if (event.checked) {
      this.tagsSelectedForMerge.push(tagName);
    } else {
      let element = this.tagsSelectedForMerge.indexOf(tagName);
      this.tagsSelectedForMerge.splice(element, 1);
    }

    if (this.tagsSelectedForMerge.length > 1) {
      this.enableMerge = true;
    } else {
      this.enableMerge = false;
    }
  }

  openMergeTagsDialog() {
    if (this.tagsSelectedForMerge.length < 2) {
      this.notificationService.error("Please select at least two tags to merge");
      return false;
    }

    const dialogref = this.dialog.open(MergeTagsDialogComponent, {
      hasBackdrop: true,
      width: '700px',
      panelClass: 'cmp-modal',
      data: {
        alertTitle: 'Merge Tags',
        tagsSelectedForMerge: this.tagsSelectedForMerge
      }
    });

    dialogref.afterClosed().subscribe(result => {
      this.enableMerge = false;
      this.store.select(state => state.tags.mergeTagsRes).subscribe(response => {
        if (response['status'] && result) {
          this.tagsSelectedForMerge = [];
        }
      })
    });
  }

  goToTagActivity() {
    this.router.navigate(['home', 'tags', 'tags-activity']);
  }
}
